import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { IStickerItem } from '../../models';

class CheckStickers implements ng.IController {
  public static $inject = ['$translate'];
  public changesMap: boolean[] = [];
  private stickers: IStickerItem[];
  private initialValues: string[] = [];

  constructor(private $translate: angular.translate.ITranslateService) {
  }

  public $onInit() {
    angular.forEach(this.stickers, (item, index) => this.initialValues[index] = item.Code);
  }

  public $onChanges(onChangesObj: angular.IOnChangesObject) {
    const changedObject: angular.IChangesObject<IStickerItem[]> = onChangesObj.stickers;
    if (!changedObject || !changedObject.currentValue || changedObject.currentValue.length === changedObject.previousValue.length
      || changedObject.currentValue.length > changedObject.previousValue.length) {
      return;
    }

    for (let i = 0; i < changedObject.previousValue.length; i++) {
      if (changedObject.previousValue[i] !== changedObject.currentValue[i]) {
        this.initialValues.splice(i, 1);
        this.changesMap.splice(i, 1);
        return;
      }
    }
  }

  public onStickerCodeChanged(index: number) {
    const initialValue = this.initialValues[index];
    if (!initialValue) {
      return;
    }

    this.changesMap[index] = this.stickers[index].Code !== initialValue;
  }

  public getPlaceholder(): string {
		return this.$translate.instant('sticker_placeholder');
  }
}

angular.module('naut').component('checkStickers', {
  template: require('./check-stickers.component.html'),
  controller: CheckStickers,
  controllerAs: 'ctrl',
  bindings: {
    header: '<',
    stickers: '<',
    iconColorClass: '<',
    isWaiting: '<',
    isReadOnly: '<',
    onAddSticker: '&',
    onDeleteSticker: '&',
    isDeleteEnable: '<'
  }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/tapAndGo/components/check-stickers/check-stickers.component.ts